module.exports = __webpack_public_path__ + "static/media/Tennis-banner.aecfbb43.jpg";